import { Editor, Node, Path } from 'slate'

export const isEmptyBlockHelper = (editor: Editor, path: Path) => {
  const [...childrenNodes] = Node.children(editor, path)

  return childrenNodes.length === 1 && !Editor.string(editor, path)
}
